{
  "title": "Datamining",
  "subtitle": "Suche und Analyse aller Agent-Konversationen",
  "import_failed": "Import fehlgeschlagen",
  "embed_status": "einbettend…",
  "loading": "Lade…",
  "no_credentials": "Noch keine Extension-Zugangsdaten vorhanden.",
  "importing": "lädt…",
  "import": "Importieren",
  "status_active": "Mirror aktiv",
  "status_inactive": "Mirror inaktiv",
  "live_feed": "Live-Feed",
  "entries": "Einträge",
  "loading": "Lade…",
  "empty": "Noch keine Daten",
  "not_configured": "HH_PG_MIRROR_DSN nicht gesetzt",
  "tabs": {
    "feed": "Live-Feed",
    "search": "Suche",
    "sessions": "Sessions",
    "stats": "Token-Stats",
    "graph": "Graph"
  },
  "search": {
    "placeholder": "Suchbegriff…",
    "filter_type_all": "Alle Typen",
    "toggle_semantic": "Semantisch",
    "submit": "Suchen",
    "no_results": "Keine Treffer",
    "results_count": "{{count}} Treffer",
    "error": "Fehler: {{message}}"
  },
  "sessions": {
    "title": "Sessions",
    "col_date": "Datum",
    "col_agent": "Agent",
    "col_user": "Benutzer",
    "col_title": "Titel",
    "col_events": "Events",
    "col_status": "Status",
    "no_sessions": "Keine Sessions vorhanden"
  },
  "session_detail": {
    "back": "Zurück",
    "events": "Events",
    "untitled": "(ohne Titel)"
  },
  "shell": {
    "running": "Shell…",
    "error": "Shell ✗",
    "button": "Shell-History",
    "prompt": "Username für Shell-History:"
  },
  "graph": {
    "loading": "lade…",
    "load": "Graph laden",
    "sessions_with_users": "Sessions mit Usern"
  },
  "stats": {
    "created": "Erstellt",
    "updated": "Zuletzt",
    "messages": "Nachrichten"
  }
}
